export const env = {
    apiUrl: process.env.REACT_APP_API_URI,
    baseUrl: process.env.REACT_APP_BASE_URI,
    formIoUrl: process.env.REACT_APP_FORM_IO_URI,
    n8nUrl: process.env.REACT_APP_N8N_URI,
    pdfUrl: process.env.REACT_APP_PDF_URI,
}
